import styled from 'styled-components';

export const StyledVisitEncounterModeField = styled.div`
   width: 220px;
`;
StyledVisitEncounterModeField.displayName = 'StyledVisitEncounterModeField';
